import React, { FC } from 'react'
import { SurveyDetails, SurveyDetailsProps } from 'surveys/components/SurveyDetails'

export const MentorshipSurveyDetails: FC<SurveyDetailsProps> = props => (
  <SurveyDetails {...props} backLink="/mentorship/surveys" backText="Back to Surveys" />
)
